export function getAllBladePositions() {
    return ['veryfirst', 'first', 'last', 'verylast'];
}
